/**
 * @param data {Data}
 * @param onAccepted {() => void}
 */
module.exports = function(data, onAccepted) {
  data.window.document.addEventListener("whenCookieLevel4Accepted", onAccepted);
};
